const GET_CONCRETE_CLASSES_100_REQUEST = 'GET_CONCRETE_CLASSES_100_REQUEST';
const GET_CONCRETE_CLASSES_100_SUCCESS = 'GET_CONCRETE_CLASSES_100_SUCCESS';
const GET_CONCRETE_CLASSES_100_ERROR = 'GET_CONCRETE_CLASSES_100_ERROR';

export {
  GET_CONCRETE_CLASSES_100_REQUEST,
  GET_CONCRETE_CLASSES_100_SUCCESS,
  GET_CONCRETE_CLASSES_100_ERROR,
};
